import { Menu, Container, Dropdown, Image } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { Link, NavLink} from 'react-router-dom';
import { useStore } from '../stores/store';
import { isMobileOnly } from 'react-device-detect';
import { FaCarSide, FaShuttleVan } from 'react-icons/fa';
import { useState } from 'react';

export default observer(function NavBar() {
    const {userStore} = useStore();
    const {user, logout} = userStore;
    const [activeMenu, setActiveMenu] = useState('');

    function renderMenu() {
        if (isMobileOnly) {
            return (
                <>
                <Menu.Item position='left' className='mobile-menu-bar'>
                    <Dropdown pointing='top left' icon='bars' >
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/'
                                text='Home' icon='home' />
                            <Dropdown.Item as={Link} to='/createPermit/carpool'>
                                <FaCarSide className='custom-icon inline' /> CARPOOL PERMIT
                            </Dropdown.Item>
                            <Dropdown.Item as={Link} to='/createPermit/vanpool'>
                                <FaShuttleVan className='custom-icon inline' /> VANPOOL PERMIT
                            </Dropdown.Item> 
                            <Dropdown.Item onClick={logout} text='Logout' icon='power' />
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Item>
                <Menu.Item header as={Link} to='/'>
                    <img src={`${process.env.PUBLIC_URL}/assets/banner.png`} alt='logo' className='logo-img' style={{ width: '300px' }} />
                </Menu.Item>
                </>
            )
        } else {
            return (
                <>
                <Menu.Item header as={Link} to='/permits'>
                    <img src={`${process.env.PUBLIC_URL}/assets/banner.png`} alt='logo' style={{ width: '300px' }} />
                </Menu.Item>
                {user &&
                    <Menu.Menu position='right'>
                        <Menu.Item 
                            name='home'
                            active={activeMenu === 'home'}
                            as={NavLink} 
                            to='/permits' 
                            onClick={(e, data) => setActiveMenu(data.name!)}
                        >
                            Home
                        </Menu.Item>
                        <Menu.Item 
                            name='carpool'
                            active={activeMenu === 'carpool'}
                            as={NavLink} 
                            to='/createPermit/carpool'
                            onClick={(e, data) => setActiveMenu(data.name!)}
                        >
                            CARPOOL PERMIT
                        </Menu.Item>
                        <Menu.Item 
                            name='vanpool'
                            active={activeMenu === 'vanpool'}
                            as={NavLink} 
                            to='/createPermit/vanpool'
                            onClick={(e, data) => setActiveMenu(data.name!)}
                        >
                            VANPOOL PERMIT
                        </Menu.Item>
                        <Menu.Item>
                            <Image avatar spaced='right' src={'assets/user.png'} />
                            <Dropdown pointing='top left' text={user.username}>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={logout} text='Logout' icon='power' />
                            </Dropdown.Menu>
                            </Dropdown>
                        </Menu.Item>
                    </Menu.Menu>
                }
                </>
            )
        }
    }

    return (
        <Menu 
            fixed='top' 
            borderless
            className='navbar'
            size='huge'
        >
            <Container>
                {renderMenu()}
            </Container>
        </Menu>
    );
})